import {ROUTES} from '../../../../../../../_gori/constants'
import {OrderType} from '../../../../../orders/core/_const'

export type Api2CartConnectionField = {
  name: string
  label: string
  required?: boolean
  type?: 'text' | 'url'
  maxLength?: number
}

export type Api2CartConnectionConfig = {
  storeType: string
  platformLabel: string
  route: string
  logoPath: string
  promoMarket?: string
  fields: Api2CartConnectionField[]
}

export const api2CartConnectionConfigs: Record<string, Api2CartConnectionConfig> = {
  [OrderType.WOOCOMMERCE]: {
    storeType: OrderType.WOOCOMMERCE,
    platformLabel: 'WooCommerce',
    route: ROUTES.SETTINGS.CONNECTIONS.WOOCOMMERCE,
    logoPath: '/media/gori/integrations/woocommerce/woocommerce-logo.svg',
    promoMarket: 'woocommerce',
    fields: [
      {
        name: 'store_name',
        label: 'STORE_NAME',
        required: true,
        type: 'text',
        maxLength: 50,
      },
      {
        name: 'store_url',
        label: 'STORE_URL',
        required: true,
        type: 'url',
        maxLength: 255,
      },
      {
        name: 'wc_consumer_key',
        label: 'CONSUMER_KEY',
        required: true,
        maxLength: 255,
      },
      {
        name: 'wc_consumer_secret',
        label: 'CONSUMER_SECRET',
        required: true,
        maxLength: 255,
      },
    ],
  },
}

export const getApi2CartConnectionConfig = (storeType: string) =>
  api2CartConnectionConfigs[storeType]
